import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { firstValueFrom } from 'rxjs';
import { IGeocoding } from '../models/geocoding.model';
import { notSendToken } from '../interceptors/refresh-token.interceptor';

@Injectable({
  providedIn: 'root'
})
export class GeocodingService {

  public URL: string = environment.copomex.url;
  public TOKEN: string = environment.copomex.token;
  private API_KEY = environment.googleMaps.apiKey;

  constructor(
    private http: HttpClient
  ) { }

  public geocoding(address: string): Promise<IGeocoding> {
    return firstValueFrom(this.http.get<IGeocoding>(`https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${this.API_KEY}`, { context: notSendToken() }));
  }
}
